import React from "react";
import { AddFilterBaseFunc, DASH_PATH_DELIMITER_UI, FilterContext, IFilter, RemoveFilterBaseFunc } from "models/core/filter";

interface IProps {
    filteredValues: IFilter;
    filterKey: string;
    removeFilter: RemoveFilterBaseFunc<any>;
}

/**
 * Component to display the path of the current hierarchy position.
 * Supports navigation and filtering back up the hierarchy.
 */
export class SimpleBreadcrumb extends React.Component<IProps, {}> {

    constructor(props) {
        super(props);
    }

    /**
     * 
     * @param p Value 
     * @param partIndex 
     */

    render = () => {
         const { filteredValues, filterKey, removeFilter } = this.props;
        const valuesLabel = filteredValues?.value;

        if (valuesLabel) {
            return (
                <div className="dash-breadcrumb">
                    
                    <span><a onClick={_ => removeFilter(filterKey)}>All</a> / </span>
                    {valuesLabel.map((p, i) => {
                        if (i !== valuesLabel.length - 1) {
                            return  <span key={filterKey+p}>{p + ", "}</span>
                        } else {
                            return <span key={filterKey+p}>{p}</span>
                        }
                    })}
                </div>
            );
        }

        return (<div className="dash-breadcrumb">&nbsp;</div>);
    }
}